import { styled } from 'baseui'

export const TableWrap = styled('div', {
  overflowX: 'auto',
  marginTop: '1.5rem',
})

export const Table = styled('table', {
  width: '100%',
  borderCollapse: 'separate',
  borderSpacing: 0,
})

export const TheadRow = styled('tr', ({ $theme }) => ({
  textAlign: 'left',
  backgroundColor: $theme.colors.bgSubtle,
}))

export const Th = styled('th', ({ $theme }) => ({
  paddingTop: '0.75rem',
  paddingBottom: '0.75rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  fontSize: '0.875rem',
  fontWeight: 400,
  color: $theme.colors.textMuted,
}))

export const ActionsTh = styled(Th, {
  textAlign: 'right',
})

export const Td = styled('td', ({ $theme }) => ({
  paddingTop: '0.75rem',
  paddingBottom: '0.75rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: $theme.colors.borderLight,
  fontSize: '0.875rem',
}))

export const ActionsTd = styled(Td, {
  textAlign: 'right',
})
